import { industryPriorities } from './industryPriorities';
import { expandedIndustries } from './industryExpansion';
export const CONTACT_PATH = "/pt-BR/#contact";
export const SALES_PHONE_TEL = "tel:+551150396241";
export const SALES_PHONE_DISPLAY = "+55 11 5039-6241";
export const SALES_WHATSAPP_URL = "https://wa.me/551150396241";
export const SECURITY_PORTAL_URL = "https://trust.zild.ai/";
export const SUPPORT_EMAIL = "support@zild.ai";

export const PRODUCTS = [
    {
        key: "admin",
        title: "Zild Admin",
        path: "/products/admin",
        summary:
            "Console para agentes, papéis, permissões, modelos, cotas, políticas e auditoria em uma camada comum.",
        sections: [
            ["Controle comum", "Times definem quem pode agir, em qual operação, com quais dados e limites."],
            ["Modelos e provedores", "A operação acompanha modelos conectados, consumo, cotas e decisões de troca."],
            ["Auditoria", "Cada turno mantém trilha de ação, validação, responsável, custo e evidência."],
        ],
        proof: ["RBAC", "Políticas", "Modelos", "Auditoria"],
    },
    {
        key: "assist",
        title: "Zild Assist",
        path: "/products/assist",
        summary:
            "Agentes em WhatsApp, e-mail e canais privados com contexto unificado e validação humana sob política.",
        sections: [
            ["Fila e contexto", "Conversas chegam com cliente, histórico, canal, SLA e operação visíveis."],
            ["Ação segura", "O agente resolve o que está dentro da política e prepara o que precisa de confirmação."],
            ["Handoff humano", "Risco, baixa confiança ou cliente crítico passam para uma pessoa com resumo e evidência."],
        ],
        proof: ["WhatsApp", "E-mail", "SLA", "Evidência"],
    },
    {
        key: "chat",
        title: "Zild Chat",
        path: "/products/chat",
        summary:
            "GPT interno seguro para colaboradores usarem IA com informações estratégicas da empresa, bases autorizadas e governança.",
        sections: [
            ["Copiloto para o time", "Colaboradores conversam com IA em um ambiente corporativo, conectado ao contexto que a empresa permite usar."],
            ["Contexto autorizado", "Respostas partem de bases, documentos, agentes e políticas liberados para cada papel."],
            ["Uso governado", "Histórico, escopo, permissão e evidência ajudam a revisar como a IA é usada dentro da operação."],
        ],
        proof: ["GPT interno", "Colaboradores", "Base autorizada", "Governança"],
    },
    {
        key: "voice",
        title: "Zild Voice",
        path: "/products/voice",
        summary:
            "Recepção, callback, prospecção e cobrança por voz com transcrição, scoring e revisão operacional.",
        sections: [
            ["Entrada telefônica", "Chamadas são atendidas, classificadas e roteadas com intenção e contexto."],
            ["Voz com política", "Scripts, limites, transferências e critérios de risco ficam explícitos."],
            ["Registro revisável", "Transcrição, resultado, transferência e nota de qualidade seguem para Insight."],
        ],
        proof: ["Telefonia", "Transcrição", "Roteamento", "QA"],
    },
    {
        key: "insight",
        title: "Zild Insight",
        path: "/products/insight",
        summary:
            "Painéis para medir agentes, humanos, filas, canais, custos, qualidade e tendências de operação.",
        sections: [
            ["Score por critério", "Conversas, chamadas e tarefas são avaliadas contra critérios definidos pelo time."],
            ["Tendência operacional", "Líderes enxergam queda de qualidade, recorrência de assunto e pontos de risco."],
            ["Decisão de melhoria", "A evidência vira ajuste de política, coaching, automação ou parada do fluxo."],
        ],
        proof: ["Scorecard", "Tendência", "Custo", "Melhoria"],
    },
    {
        key: "tasks",
        title: "Zild Flow",
        path: "/products/flow",
        summary:
            "Gerencie tarefas associadas a pessoas ou agentes de IA com uma visualização clara da execução de processos.",
        sections: [
            ["Processos em uma só visão", "Acompanhe etapas, responsáveis, prazos e dependências ao longo de cada execução."],
            ["Humanos e agentes de IA", "Distribua tarefas entre pessoas e agentes, mantendo handoffs, exceções e contexto visíveis."],
            ["Execução rastreável", "Monitore o andamento do processo, identifique bloqueios e preserve o histórico de cada ação."],
        ],
        proof: ["Processos", "Tarefas", "Pessoas", "Agentes de IA"],
    },
    {
        key: "coach",
        title: "Zild Coach",
        path: "/products/coach",
        summary:
            "Treinamento, simulação, avaliação por critério e planos de coaching para agentes humanos e de IA.",
        sections: [
            ["Cenários reais", "Casos recorrentes viram simulações com persona, regra, risco e resposta esperada."],
            ["Avaliação por critério", "O time mede aderência à política, tom, resolução e handoff."],
            ["Plano de melhoria", "Evidência do Insight alimenta coaching, treinamento e revisão de agente."],
        ],
        proof: ["Roleplay", "Critério", "Treino", "Ajuste"],
    },
];

export const SOLUTIONS = [
{
    "key": "logistics-control-tower",
    "title": "Torre de controle logística com IA: antecipe exceções e coordene a operação.",
    "shortTitle": "Torre de controle logística",
    "path": "/solutions/logistics-control-tower",
    "summary": "Conecte pedidos, transportadoras e sistemas de gestão em uma visão operacional. Use IA para acompanhar entregas, priorizar ocorrências e manter clientes e parceiros informados.",
    "sections": [
        [
            "Visibilidade ponta a ponta",
            "Integre dados de TMS, WMS, ERP e parceiros para reunir coletas, entregas, prazos e comprovantes em um só fluxo."
        ],
        [
            "Exceções priorizadas",
            "Identifique atrasos, falta de atualização e divergências. Agentes organizam as ocorrências por impacto e SLA, com responsável e próxima ação."
        ],
        [
            "Comunicação coordenada",
            "Automatize consultas de status e atualizações por canais conectados. Negociações, reprogramações e casos críticos seguem para aprovação humana."
        ],
        [
            "Decisões com evidência",
            "Acompanhe indicadores de entrega e recorrência de problemas com histórico de ações, documentos e decisões para melhorar a operação."
        ]
    ],
    "proof": [
        "TMS / WMS",
        "ERP",
        "SLA",
        "Exceções"
    ]
},
{
    "key": "civil-engineering",
    "title": "Engenharia civil: transforme dados de projetos em decisões com IA.",
    "shortTitle": "IA para engenharia civil",
    "path": "/solutions/civil-engineering",
    "summary": "Integre AutoCAD e SketchUp aos processos da sua empresa para extrair e organizar dados de projetos de engenharia. Reduza levantamentos manuais e conecte informações de projeto a orçamento, planejamento e acompanhamento da obra.",
    "sections": [
        [
            "Projetos conectados",
            "Estruturamos a integração com AutoCAD e SketchUp conforme as versões, os formatos e os dados disponíveis, conectando arquivos, exportações ou interfaces de integração ao fluxo da empresa."
        ],
        [
            "Extração de dados de engenharia",
            "Organize atributos, dimensões, áreas, volumes e quantitativos quando presentes nos desenhos e modelos. Preserve a origem e a revisão do projeto para conferir cada informação."
        ],
        [
            "Do projeto à gestão",
            "Leve os dados extraídos para planilhas, ERP e ferramentas de planejamento por meio dos conectores disponíveis, apoiando orçamentos, compras e acompanhamento de alterações."
        ],
        [
            "Validação pela engenharia",
            "O responsável técnico revisa quantitativos, divergências e informações incompletas antes de liberar os dados para decisões de orçamento, compra ou execução."
        ]
    ],
    "proof": [
        "AutoCAD",
        "SketchUp",
        "Quantitativos",
        "Revisão técnica"
    ]
},

    {
        key: "customer-service",
        title: "IA para atendimento por WhatsApp, SAC e canais digitais.",
        shortTitle: "IA para atendimento e SAC",
        path: "/solutions/customer-service",
        summary:
            "O Assist resolve rotinas de atendimento, leva momentos sensíveis para pessoas e mantém evidência pronta para QA.",
        sections: [
            ["Antes da Zild", "Pedidos repetidos, follow-ups perdidos e contexto espalhado entre caixas de entrada."],
            ["Fluxo implantado", "O agente identifica intenção, consulta contexto, resolve o que é seguro e prepara próximas ações."],
            ["Regras de controle", "Baixa confiança, risco de política, SLA pressionado ou cliente crítico passam para uma pessoa."],
            ["Evidência capturada", "Transcrição, motivo da transferência, responsável, resultado, nota de qualidade e custo ficam juntos."],
        ],
        proof: ["Assist", "Insight", "Tasks", "Validação humana"],
    },
    {
        key: "sales-and-sdr",
        title: "IA SDR para qualificar, fazer follow-up e manter evidência no CRM.",
        shortTitle: "IA SDR e vendas",
        path: "/solutions/sales-and-sdr",
        summary:
            "Qualificação, contexto do lead, objeções, atualização de CRM e handoff para vendedores em um fluxo supervisionado.",
        sections: [
            ["Entrada comercial", "Leads chegam por formulário, WhatsApp, e-mail ou listas com origem e contexto."],
            ["Qualificação", "O agente aplica critérios, coleta lacunas, registra objeções e recomenda o próximo passo."],
            ["Handoff para vendas", "Oportunidades quentes chegam ao vendedor com resumo, histórico e tarefa."],
            ["CRM atualizado", "Campos, etapa, motivo e próxima ação ficam registrados para liderança comercial."],
        ],
        proof: ["Qualificação", "CRM", "Follow-up", "Handoff"],
    },
    {
        key: "outbound-operations",
        title: "IA para outbound, cobrança e follow-up ativo.",
        shortTitle: "IA para outbound e cobrança",
        path: "/solutions/outbound-operations",
        summary:
            "Contato ativo por e-mail, voz e WhatsApp com política, contexto de conta e próxima ação clara.",
        sections: [
            ["Carteira priorizada", "Contas entram por valor, atraso, risco, segmento ou oportunidade."],
            ["Contato governado", "Mensagens e chamadas respeitam tom, janela, política e limites de cobrança."],
            ["Exceções com dono", "Promessa, contestação, cliente sensível ou baixa confiança vai para humano."],
            ["Ciclo fechado", "Resultado, tentativa, custo e próxima ação alimentam Tasks e Insight."],
        ],
        proof: ["Cobrança", "Outbound", "Voice", "Tasks"],
    },
    {
        key: "voice-reception",
        title: "IA para voz, recepção e transferência com contexto.",
        shortTitle: "IA para voz e recepção",
        path: "/solutions/voice-reception",
        summary:
            "Atendimento telefônico com classificação de intenção, transferência assistida, transcrição e evidência.",
        sections: [
            ["Chamada recebida", "O agente atende, entende motivo, confirma dados e localiza contexto."],
            ["Roteamento", "A ligação segue para área, fila ou retorno conforme regra operacional."],
            ["Transferência assistida", "Quando uma pessoa assume, recebe resumo, intenção, dados e histórico."],
            ["Monitoria", "Transcrição e score alimentam QA, coaching e ajustes de script."],
        ],
        proof: ["Recepção", "Callback", "Transferência", "QA"],
    },
    {
        key: "quality-monitoring",
        title: "IA para monitoria de qualidade em conversas e chamadas.",
        shortTitle: "IA para monitoria de qualidade",
        path: "/solutions/quality-monitoring",
        summary:
            "QA contínua com critérios, exemplos reais, sinais de risco, coaching e melhoria de política.",
        sections: [
            ["Critérios claros", "O time define o que é bom atendimento, risco, tom, resolução e conformidade."],
            ["Avaliação contínua", "Conversas e chamadas são pontuadas com evidência e exemplos."],
            ["Ação de melhoria", "Tendências viram coaching, revisão de macro, ajuste de agente ou mudança de política."],
            ["Visão executiva", "Liderança acompanha filas, canais, temas críticos e evolução por período."],
        ],
        proof: ["Score", "QA", "Coaching", "Tendência"],
    },
    {
        key: "document-intake",
        title: "IA para documentos, intake e revisão humana.",
        shortTitle: "IA para documentos",
        path: "/solutions/document-intake",
        summary:
            "Classificação, extração, checklist e exceções com revisão humana quando a decisão tem risco.",
        sections: [
            ["Documento recebido", "Arquivos entram com origem, tipo, cliente e campos esperados."],
            ["Extração e checklist", "O agente extrai dados, marca confiança e compara contra regra."],
            ["Revisão por exceção", "Baixa confiança, campo ausente ou risco de política vai para uma pessoa."],
            ["Próxima tarefa", "O resultado fecha intake, atualiza sistemas e abre follow-up quando necessário."],
        ],
        proof: ["OCR", "Checklist", "Revisão", "Tasks"],
    },
    {
        key: "internal-operations",
        title: "IA para backoffice e rotinas internas com dono.",
        shortTitle: "IA para backoffice",
        path: "/solutions/internal-operations",
        summary:
            "Enriquecimento, limpeza de CRM, tarefas recorrentes e exceções operacionais com responsável claro.",
        sections: [
            ["Rotina recorrente", "O fluxo começa por tarefas repetidas que já consomem tempo do time."],
            ["Agente executa", "O agente consulta sistemas, atualiza registros e prepara exceções."],
            ["Dono humano", "Bloqueios, dúvidas e decisões sensíveis chegam com contexto para o responsável."],
            ["Evidência de produtividade", "Tempo, volume, erro evitado e retrabalho ficam mensuráveis."],
        ],
        proof: ["Backoffice", "Chat", "SLA", "Dono"],
    },
    {
        key: "custom-workflow",
        title: "Projeto de IA sob medida para fluxos operacionais.",
        shortTitle: "Projeto de IA sob medida",
        path: "/solutions/custom-workflow",
        summary:
            "Mapeie regras, sistemas, donos e evidências ao redor do fluxo que o seu time realmente roda.",
        sections: [
            ["Mapeamento", "A conversa identifica volume, donos, sistemas, risco, canais e critérios de sucesso."],
            ["Desenho da operação", "O fluxo define o que o agente faz, quando valida e que evidência fica."],
            ["Piloto controlado", "A primeira versão roda com escopo estreito e revisão de cada exceção."],
            ["Escala por evidência", "Expansão depende de métricas, qualidade, custo e confiança operacional."],
        ],
        proof: ["Diagnóstico", "Piloto", "Validação", "Escala"],
    },
];

export const INDUSTRIES = [
...expandedIndustries,
{
    "key": "civil-engineering",
    "title": "Engenharia civil: transforme dados de projetos em decisões com IA.",
    "shortTitle": "Engenharia civil",
    "path": "/industries/civil-engineering",
    "summary": "Integre AutoCAD e SketchUp aos processos da sua empresa para extrair e organizar dados de projetos de engenharia. Reduza levantamentos manuais e conecte informações de projeto a orçamento, planejamento e acompanhamento da obra.",
    "sections": [
        [
            "Projetos conectados",
            "Estruturamos a integração com AutoCAD e SketchUp conforme as versões, os formatos e os dados disponíveis, conectando arquivos, exportações ou interfaces de integração ao fluxo da empresa."
        ],
        [
            "Extração de dados de engenharia",
            "Organize atributos, dimensões, áreas, volumes e quantitativos quando presentes nos desenhos e modelos. Preserve a origem e a revisão do projeto para conferir cada informação."
        ],
        [
            "Do projeto à gestão",
            "Leve os dados extraídos para planilhas, ERP e ferramentas de planejamento por meio dos conectores disponíveis, apoiando orçamentos, compras e acompanhamento de alterações."
        ],
        [
            "Validação pela engenharia",
            "O responsável técnico revisa quantitativos, divergências e informações incompletas antes de liberar os dados para decisões de orçamento, compra ou execução."
        ]
    ],
    "proof": [
        "AutoCAD",
        "SketchUp",
        "Quantitativos",
        "Revisão técnica"
    ]
},

    {
        key: "healthcare",
        title: "IA para operações de saúde com controle de atendimento.",
        shortTitle: "Saúde",
        path: "/industries/healthcare",
        summary:
            "Triagem, agendamento, confirmação, documentos e follow-up com política, privacidade e evidência.",
        sections: [
            ["Entrada de paciente", "Pedidos chegam por WhatsApp, telefone ou formulário com contexto clínico-operacional."],
            ["Roteamento seguro", "O agente separa dúvidas administrativas de casos que exigem equipe responsável."],
            ["Registro e retorno", "Confirmação, documento pendente, agendamento e follow-up ficam rastreáveis."],
        ],
        proof: ["Triagem", "Agenda", "Privacidade", "Follow-up"],
    },
    {
        key: "financial-services",
        title: "IA para serviços financeiros com política e evidência.",
        shortTitle: "Serviços financeiros",
        path: "/industries/financial-services",
        summary:
            "Atendimento, cobrança, documentos, risco operacional e QA com limites claros para cada decisão.",
        sections: [
            ["Contexto de conta", "A operação usa perfil, histórico, produto e política para orientar a ação."],
            ["Contato ativo", "Cobrança e follow-up seguem tom, janela, política e evidência."],
            ["Auditoria", "Decisões, exceções e resultados permanecem revisáveis por compliance e liderança."],
        ],
        proof: ["Política", "Cobrança", "Auditoria", "QA"],
    },
    {
        key: "logistics",
        title: "IA para logística, status, exceções e comunicação operacional.",
        shortTitle: "Logística",
        path: "/industries/logistics",
        summary:
            "Status de entrega, coleta, exceção, documento e comunicação com cliente em fluxos rastreáveis.",
        sections: [
            ["Torre de controle logística", "Conecte pedidos, transportadoras e sistemas de gestão em uma visão operacional. Use IA para acompanhar entregas, priorizar ocorrências e manter clientes e parceiros informados."],
            ["Pedido em movimento", "O agente consulta status, rota, prazo, documento e histórico de contato."],
            ["Exceção operacional", "Atraso, avaria, divergência ou cliente crítico vira tarefa com responsável."],
            ["Comunicação contínua", "Cliente, operação e parceiro recebem atualização com registro comum."],
        ],
        proof: ["Status", "Exceção", "Parceiros", "SLA"],
    },
    {
        key: "customer-operations",
        title: "IA para operações de cliente com SLA, fila e qualidade.",
        shortTitle: "Operações de cliente",
        path: "/industries/customer-operations",
        summary:
            "Atendimento, receita, retenção, QA e backoffice operando no mesmo modelo de controle.",
        sections: [
            ["Fila unificada", "Canais, prioridade, cliente e SLA aparecem como uma operação, não como caixas soltas."],
            ["Controle humano", "Casos sensíveis passam para pessoas com contexto e trilha clara."],
            ["Melhoria contínua", "Insight e Coach transformam evidência em ajuste de equipe, política e agente."],
        ],
        proof: ["Fila", "SLA", "Retenção", "Coaching"],
    },
];

// Keep existing detail URLs while aligning the public industry focus.
industryPriorities.forEach(priority => {
    const item = INDUSTRIES.find(candidate => candidate.key === priority.key);
    if (item) { item.shortTitle = priority.name; item.summary = priority.summary; }
});

export const ROUTE_PAGES = {
    products: {
        layout: "collection",
        title: "Sete apps, uma camada de operação.",
        summary:
            "Admin define limites. Assist e Voice operam a linha de frente. Chat dá um GPT interno seguro para o time. Tasks transforma registros em ação. Insight e Coach fecham o ciclo de melhoria.",
        sections: PRODUCTS.map((item) => ({
            title: item.title,
            body: item.summary,
            path: item.path,
            meta: item.proof.join(" · "),
        })),
        proof: ["8 apps", "1 camada", "controle comum", "evidência"],
    },
    solutions: {
        layout: "collection",
        title: "Comece pelo fluxo que já pressiona a operação.",
        summary:
            "Atendimento, vendas, voz, documentos e backoffice entram no mesmo modelo: regra antes da ação, humano quando importa e evidência para melhorar.",
        sections: SOLUTIONS.map((item) => ({
            title: item.shortTitle,
            body: item.summary,
            path: item.path,
            meta: item.proof.join(" · "),
        })),
        proof: ["fluxo real", "piloto controlado", "handoff humano", "evidência"],
    },
    industries: {
        layout: "collection",
        title: "IA conectada aos desafios da sua indústria.",
        summary: "Da indústria de transformação aos serviços, conecte conhecimento, documentos e processos para apoiar suas equipes. Explore as oportunidades de IA no contexto da sua operação.",
        sections: industryPriorities.map(item => ({ title: item.name, body: item.summary, path: `/industries/${item.key}`, meta: item.meta })),
        proof: ["Conhecimento", "Documentos", "Processos", "Governança"],
    },
    implementation: {
        layout: "timeline",
        title: "Consultoria para transformar IA em resultado.",
        summary:
            "Automatize processos, acelere a adoção, democratize o acesso à IA e tome melhores decisões de investimento com FinOps. A Zild conecta estratégia, pessoas e sistemas para levar sua empresa do plano à prática.",
        sections: [
            ["Diagnóstico", "Escolha fluxo, volume, dono, sistemas, riscos e sinal de sucesso."],
            ["Desenho", "Defina ação do agente, política, integrações, handoff, QA e evidência."],
            ["Go-live", "Rode com usuários reais enquanto operadores acompanham exceções e custo."],
            ["Revisão", "Use resultados para expandir, mudar política, treinar ou parar o fluxo."],
        ],
        proof: ["Automação", "Adoção", "Democratização", "FinOps"],
    },
};

PRODUCTS.forEach((item) => {
    ROUTE_PAGES[`products/${item.key}`] = {
        layout: "detail",
        title: item.title,
        summary: item.summary,
        sections: item.sections,
        proof: item.proof,
        relatedTitle: "Outros apps da plataforma",
        related: PRODUCTS.filter((candidate) => candidate.key !== item.key).slice(0, 3),
    };
});

ROUTE_PAGES["products/flow"] = ROUTE_PAGES["products/tasks"];

SOLUTIONS.forEach((item) => {
    ROUTE_PAGES[`solutions/${item.key}`] = {
        layout: "detail",
        title: item.title,
        summary: item.summary,
        sections: item.sections,
        proof: item.proof,
        relatedTitle: "Outros fluxos operacionais",
        related: SOLUTIONS.filter((candidate) => candidate.key !== item.key).slice(0, 3),
    };
});

INDUSTRIES.forEach((item) => {
    ROUTE_PAGES[`industries/${item.key}`] = {
        layout: "detail",
        title: item.title,
        summary: item.summary,
        sections: item.sections,
        proof: item.proof,
        relatedTitle: "Outros setores",
        related: INDUSTRIES.filter((candidate) => candidate.key !== item.key).slice(0, 3),
    };
});

export const CAMPAIGN_ALIASES = {
    "ia-para-atendimento": "solutions/customer-service",
    "ia-para-atendimento-ao-cliente": "solutions/customer-service",
    "ia-para-sac": "solutions/customer-service",
    "ia-sac": "solutions/customer-service",
    "ia-sdr": "solutions/sales-and-sdr",
    "ia-para-sdr": "solutions/sales-and-sdr",
    "ia-para-vendas": "solutions/sales-and-sdr",
    "ia-para-cobranca": "solutions/outbound-operations",
    "ia-cobranca": "solutions/outbound-operations",
    "cobranca-com-ia": "solutions/outbound-operations",
    "ia-para-outbound": "solutions/outbound-operations",
    "ia-outbound": "solutions/outbound-operations",
    "ia-para-voz": "solutions/voice-reception",
    "ia-telefonica": "solutions/voice-reception",
    "ia-para-recepcao": "solutions/voice-reception",
    "ia-para-documentos": "solutions/document-intake",
    "ia-para-monitoria": "solutions/quality-monitoring",
    "ia-para-qualidade": "solutions/quality-monitoring",
    "ia-para-backoffice": "solutions/internal-operations",
    "automacao-com-ia": "solutions/custom-workflow",
};

export const BLOG_POSTS = [
    {
        slug: "como-escolher-primeiro-fluxo-agente-ia",
        category: "Implantação",
        title: "Como escolher o primeiro fluxo para um agente de IA",
        excerpt:
            "Critérios práticos para encontrar volume, risco, validação humana e evidência antes da primeira implantação.",
        readTime: "6 min",
        sections: [
            [
                "Comece onde o trabalho já acontece",
                "O melhor primeiro fluxo não é o mais chamativo. É o que já tem volume, dono claro e repetição suficiente para medir antes e depois.",
                "Em empresas brasileiras, isso costuma aparecer em atendimento por WhatsApp, triagem comercial, recepção por voz, entrada de documentos ou follow-up de exceções internas.",
            ],
            [
                "Procure limite operacional, não só automação",
                "Um bom fluxo para agente tem uma fronteira clara: o que a IA pode resolver, quando precisa pedir confirmação e quando o caso deve passar para uma pessoa.",
                "Se essa fronteira ainda não existe, o primeiro trabalho é desenhar política, SLA, risco e dono humano antes de colocar o agente em produção.",
            ],
            [
                "Exija evidência desde o primeiro dia",
                "Cada execução precisa deixar registro: entrada, resposta, motivo de validação humana, resultado, custo, nota de qualidade e próxima ação.",
                "Sem evidência, o projeto vira opinião. Com evidência, a operação consegue corrigir, expandir ou parar o fluxo com segurança.",
            ],
        ],
    },
    {
        slug: "handoff-humano-agentes-ia-o-que-registrar",
        category: "Governança",
        title: "O que registrar quando um agente passa uma conversa para uma pessoa",
        excerpt:
            "Transcrição, motivo, dono, SLA, custo e nota de qualidade tornam o fluxo auditável.",
        readTime: "5 min",
        sections: [
            [
                "Handoff não é exceção invisível",
                "Quando um agente passa uma conversa para uma pessoa, a operação ganha uma decisão importante. Esse momento revela risco, dúvida, política, pressão de SLA ou valor do cliente.",
                "Se o registro fica solto, ninguém aprende. Se fica estruturado, ele vira material para QA, política e treinamento.",
            ],
            [
                "O pacote mínimo de evidência",
                "Registre a transcrição, o resumo do caso, o motivo do handoff, a pessoa responsável, o SLA, a ação recomendada, o custo e o resultado final.",
                "Esses campos permitem revisar se a validação humana foi correta, se o agente deveria ter resolvido sozinho ou se a política precisa mudar.",
            ],
            [
                "Como isso melhora a operação",
                "Com evidência consistente, líderes deixam de avaliar agentes por sensação. Eles enxergam tendências, assuntos que escalam demais, políticas confusas, canais com mais risco e times que precisam de apoio.",
                "A melhoria deixa de depender de reuniões longas e passa a vir do próprio fluxo de trabalho.",
            ],
        ],
    },
    {
        slug: "automacao-documental-revisao-humana",
        category: "Documentos",
        title: "Quando automação documental precisa de revisão humana",
        excerpt:
            "Baixa confiança, documento incompleto e risco de política são sinais de que o próximo passo precisa de controle.",
        readTime: "4 min",
        sections: [
            [
                "Documentos não são todos iguais",
                "Extração simples pode ser automatizada. Decisão operacional exige mais cuidado: confiança do campo, completude, política aplicável e impacto do erro.",
                "O fluxo precisa separar o que pode seguir sozinho do que deve voltar para uma pessoa com contexto suficiente para decidir rápido.",
            ],
            [
                "Três sinais para revisão humana",
                "Revise quando a confiança estiver baixa, quando faltar informação crítica ou quando a decisão afetar cliente, dinheiro, conformidade ou prazo.",
                "A revisão deve receber o documento, os campos extraídos, a dúvida do agente, a política aplicável e a próxima ação sugerida.",
            ],
            [
                "O resultado precisa voltar para o sistema",
                "Depois da revisão, o resultado deve atualizar o registro, fechar a tarefa e alimentar o histórico de qualidade.",
                "Assim, cada exceção documental melhora o próximo ciclo em vez de virar retrabalho escondido.",
            ],
        ],
    },
];
